<template>
  <div id="Heating">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.heating.title") }}</div>
      <div class="container inline bottom">
        <EnergyButton 
          @click="heating = 'elec'"
          :active="heating === 'elec'"
          :title="$t('elec')"
          type="elec"
        />
        <EnergyButton 
          @click="heating = 'gas'"
          :active="heating === 'gas'"
          :title="$t('gas')"
          type="gas"
        />
        <EnergyButton 
          @click="heating = 'heat_pump'"
          :active="heating === 'heat_pump'"
          :title="$t('heat_pump')"
          type="heater_pump"
        />
        <EnergyButton 
          @click="heating = 'other'"
          :active="heating === 'other'"
          :title="$t('other')"
          type="other"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EnergyButton from "@/components/Energy/EnergyButton.vue";

export default {
  computed: {
    ...mapState("energy", ["type"]),
    heating: {
      get() {
        return this.$store.state.consumption.heating;
      },
      set(value) {
        this.$store.commit("consumption/setHeating", value);
      }
    }
  },
  created() {
    if (!this.heating) {
      if (this.type === "elec") this.heating = "other"
      else this.heating = "gas";
    }
  },
  components: {
    EnergyButton
  }
};
</script>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/HeaterType.vue